module.exports = PropTypes;


//////////////////
// WEBPACK FOOTER
// external "PropTypes"
// module id = 19
// module chunks = 1